/**
 * 数组是否包含value值
 * @param {*} value
 * @param {*} validList
 */
function oneOf(value, validList) {
  for(let i = 0; i < validList.length; i++) {
    if(value === validList[i]) {
      return true
    }
  }
  return false
}

export {
  oneOf
}



// WEBPACK FOOTER //
// ./src/utils/assist.js